import { useEffect, useState } from 'react'

export const useFirstTimeSeen = (key: string) => {
  const storageKey = `first-time-seen:${key}`
  const [isFirstTime, setIsFirstTime] = useState(false)

  useEffect(() => {
    const seen = localStorage.getItem(storageKey)
    if (!seen) setIsFirstTime(true)
  }, [storageKey])

  const markAsSeen = () => {
    localStorage.setItem(storageKey, 'true')
    setIsFirstTime(false)
  }

  return { isFirstTime, markAsSeen }
}

export const resetFirstTimeSeen = (key: string) => {
  const storageKey = `first-time-seen:${key}`
  localStorage.removeItem(storageKey)
}

export const resetAllFirstTimeSeen = () => {
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('first-time-seen:')) {
      localStorage.removeItem(key)
    }
  })
}
